<template>
  <modal name="le-schedule-game-modal" :adaptive="true" height="auto">
    <form @submit.prevent="submit">
      <ntm-block :collapsable="false" :title="title">
        <template #options>
          <button type="button" class="btn btn-sm btn-light" @click="$modal.hide('le-schedule-game-modal')" v-tooltip="$t('close')">
            <i class="fa fa-times"></i>
          </button>
        </template>
        <formly-form data-testid="schedule-game-form" :form="form" :model="model" :fields="fields"></formly-form>
        <button type="submit" class="btn btn-success push-15" data-testid="schedule-game-save" :disabled="loading">
          <span v-if="!loading">{{ $t('save') }}</span>
          <i v-if="loading" class="fa fa-cog fa-spin"></i>
        </button>
      </ntm-block>
    </form>
  </modal>
</template>

<script>
import GameService from '@/services/game.service'
import { useTimeline } from '@/use/useTimeline'
import scheduleFormDefinition from '@/views/schedules/games/formDefinitions/scheduleFormDefinition'

export default {
  props: {
    venues: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      form: {},
      fields: JSON.parse(JSON.stringify(scheduleFormDefinition)),
      model: {},
      loading: false,
      scheduleUuid: null
    }
  },
  setup () {
    const { fetchCurrentTimeline } = useTimeline()
    return { fetchCurrentTimeline }
  },
  computed: {
    title () {
      const home = this.model?.teamA?.name
      const away = this.model?.teamB?.name
      return `${home} --:-- ${away}`
    }
  },
  methods: {
    open (game, scheduleUuid = null) {
      this.scheduleUuid = scheduleUuid || game.schedule?.uuid
      this.model = game

      if (!this.model.time) {
        const d = new Date()
        const date = d.toISOString().split('T')[0]
        const time = d.toTimeString().split(' ')[0].split(':').slice(0, 2).join(':')
        this.model.time = `${date} ${time}`
      }

      const venuesField = this.fields.find(f => f.key === 'venue')
      if (this.venues.length) {
        venuesField.options = this.venues
        venuesField.optionsApi = null
        if (!game.venue && this.venues.length === 1) {
          game.venue = this.venues[0]
        }
      } else {
        venuesField.options = null
        venuesField.optionsApi = 'venues'
      }

      this.$modal.show('le-schedule-game-modal')
    },
    submit () {
      this.loading = true
      GameService.scheduleGame(this.scheduleUuid, this.model.uuid, {
        time: this.model.time,
        venue: this.model.venue,
        info: this.model.info
      }).then((res) => {
        this.model.time = res.data.time
        this.model.venue = res.data.venue
        this.model.code = res.data.code
        this.model.status = res.data.status
        this.fetchCurrentTimeline()
        this.$emit('saved', res.data)
        this.$modal.hide('le-schedule-game-modal')
      }).catch((err) => {
        this.form.$errors = err.response?.data?.errors
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
